import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { ModuleId, ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { ElementPreview } from 'modules/forms/components/preview/ElementPreview'
import { useLoadResponses } from 'modules/forms/hooks/useForms'
import { Element } from 'modules/forms/lib/Element'
import { SectionElement } from 'modules/forms/lib/elements/SectionElement'

interface FormResponsesSidepanelProps {
  membershipId: string
  resourceType: string
  materializedFormResourceType: string
  formId: string
  resourceHeaderModule?: {
    id: ModuleId
    label: string
    href: string
  }
  respondentId?: string
  isOpen: boolean
  onClose: () => void
  showElementName?: boolean
  titleSize?: 'default' | 'small'
}

export const FormResponsesSidepanel = ({
  formId,
  materializedFormResourceType,
  resourceType,
  membershipId,
  resourceHeaderModule,
  isOpen,
  onClose,
  respondentId,
  showElementName = true,
  titleSize = 'default',
}: FormResponsesSidepanelProps) => {
  const { form } = useLoadResponses({
    membershipId: membershipId,
    resourceType: resourceType,
    materializedFormResourceType: materializedFormResourceType,
    formId: formId,
    respondentId,
  })
  return (
    <F0Dialog onClose={onClose} isOpen={isOpen} position="right" module={resourceHeaderModule}>
      <Box paddingX="s16" gap="s32">
        <ResourceHeader
          title={form?.title ?? ''}
          metadata={
            form?.status === 'active'
              ? [
                  form?.formType === 'satisfaction' && {
                    label: i18n.t('forms.visibility'),
                    value: {
                      type: 'text',
                      content: form?.anonymous
                        ? i18n.t('forms.anonymous')
                        : i18n.t('forms.visible'),
                    },
                  },
                ]
              : []
          }
          status={{
            label: '',
            text:
              form?.status === 'active'
                ? i18n.t('trainings.surveys.status.sent')
                : i18n.t('trainings.surveys.status.draft'),
            variant: form?.status === 'active' ? 'positive' : 'neutral',
          }}
        />
      </Box>
      <Box gap="s32" width="full">
        <Box padding="s24" gap="s24" borderRadius={{ all: 'abs016' }}>
          {form?.elements.map((element: Element, index) => (
            <>
              <ElementPreview
                key={index}
                element={element}
                mode="response"
                showElementName={showElementName}
                titleSize={titleSize}
              />
              {element instanceof SectionElement && (
                <>
                  {element.elements.map((child: Element, childIndex) => (
                    <ElementPreview
                      key={childIndex}
                      element={child}
                      mode="response"
                      showElementName={showElementName}
                      titleSize={titleSize}
                    />
                  ))}
                  <Box flexDirection="row" alignItems="center">
                    <Box
                      width="full"
                      className="border-solid border-0 border-t border-f1-border-secondary"
                    />
                    <Text.Normal whiteSpace="nowrap" className="text-base p-3">
                      {i18n.t('forms.section_end')}
                    </Text.Normal>
                    <Box
                      width="full"
                      className="border-solid border-0 border-t border-f1-border-secondary"
                    />
                  </Box>
                </>
              )}
            </>
          ))}
        </Box>
      </Box>
    </F0Dialog>
  )
}
